import { Helmet } from 'react-helmet-async';
// @mui
import StarOutlineSharpIcon from '@mui/icons-material/StarOutlineSharp';
import StarPurple500SharpIcon from '@mui/icons-material/StarPurple500Sharp';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import {
  Grid,
  Container,
  Typography,
  Box,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
  CircularProgress,
} from '@mui/material';
// components
import { useSelector } from 'react-redux';
import GoogleMapReact from 'google-map-react';
// sections
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import axios from 'axios';
import TripSource from 'src/sections/@dashboard/app/TripSource';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useParams } from 'react-router-dom';


export default function DashboardAppPage() {
  const { mashawiritoken } = useSelector((state) => state.auth);
  const { mashawiriuser } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const [current, setCurrent] = useState('');
  const [citySrc, setCitySrc] = useState('');
  const [selectedPlaceSrc, setSelectedPlaceSrc] = useState('');

  const [distination, setDistination] = useState('');
  const [cityDis, setCityDis] = useState('');
  const [selectedPlaceDis, setSelectedPlaceDis] = useState('');


  const [carType, setCarType] = useState([]);
  const [selectedCar, setSelectedCar] = useState(1);
  const [notes, setNotes] = useState([]);
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [Admin, setAdmin] = useState();
  const [driverPhone, setDriverPhone] = useState();
  const [btn,setBtn] = useState(true)

  const handleSelecteCar = (e) => {
    setSelectedNotes([]);
    var selectedIndex = e.target.selectedIndex;
    setSelectedCar(e.target.value);
      setNotes(carType[selectedIndex].notes)
  };
  const { t } = useTranslation();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}get_cars_with_notes`, {
        headers: {
          Authorization: `Bearer ${mashawiritoken}`,
        },
      })
      .then((res) => {
        setCarType(res.data.cars);
        setNotes(res.data.cars[0].notes)
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);



  const handleSelectNote = (e) => {
    setSelectedNotes(e.target.value);
  };

  const [scheduled, setScheduled] = useState(false);

  const handleChangeScheduled = (e) => {
    setScheduled(e.target.checked);
  };

  //handle date and time picker

  const [selectedDateTime, setSelectedDateTime] = useState(null);

  const handleChangeTime = (newValue) => {
    if (newValue) {
      const formattedDateTime = newValue.format('YYYY-MM-DD HH:mm:ss');
      setSelectedDateTime(formattedDateTime);
    } else {
      setSelectedDateTime(null);
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}clients_in_my_company`, {
        headers: {
          Authorization: `Bearer ${mashawiritoken}`,
        },
      })
      .then((res) => {
        setClients(res.data.data);
        console.log(res.data.data)
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleCreateTrip = () => {
    setLoading(true);
    const tripData = {
      phone: mashawiriuser.phone,
      multi_client: JSON.stringify(dataUsers),
      current,
      destination: distination,
      city: citySrc,
      city_name_destination: cityDis,
      current_name: selectedPlaceSrc,
      destination_name: selectedPlaceDis,
      cartype_id: parseInt(selectedCar),
      notes: selectedNotes,
      driver_phone:driverName
  }
    if (scheduled) {
      const date = selectedDateTime;
      const millSecond = Date.parse(date);
      const dateObj = new Date(millSecond);
      tripData.trip_type = 1;
      tripData.date = selectedDateTime;
    }
    console.log('tripData',tripData) 
//////////////////////////////////////////////////////create_trip sending comment

    axios
      .post(`${process.env.REACT_APP_API_URL}create_trip_company`, tripData, {
        headers: {
          Authorization: `Bearer ${mashawiritoken}`,
        },
      })
      .then((res) => {
        setLoading(false);
        console.log(res);
        if(res.data.message === 'The current field is required.'){
          alert(t('One Field is empty')) 
        }
        else{
          alert('Trip created Successfully ! waiting the driver to accept')
          window.location.reload()
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    };

  //handle client in company
  const [clients, setClients] = useState(['']);
  const [selecteUser, setSelectUser] = useState([]);
  const [dataUsers, setDataUsers] = useState([]);

  const handleSelectUser = (e) => {
    const selectedUserName = e.target.value;     
    setSelectUser([...selecteUser, { name: selectedUserName.split('-')[0] }]);
    setDataUsers([...dataUsers, { phone: selectedUserName.split('-')[1], region: '' ,admin: ''}]);
  };


  const handleUserPlaceChange = (e, index) => {
    setDataUsers((prevDataUsers) => {
      const newDataUsers = [...prevDataUsers];
      newDataUsers[index].region = e.target.value;
      return newDataUsers;
    });
  };


  const [token , setToken] = useState("")
  const [isShownId, setIsShownId] = useState(0);

  const {id} = useParams();

const defaultProps = {
  center: {
    lat: 33.515978,
    lng: 36.2934367,
  },
  zoom: 11,
};

const [itemStates,setItemStates]=useState([])
const handleBlackClick =(i) =>{
  setItemStates(prevStates => {
    const updatedStates = [...prevStates];
    updatedStates[i] = !updatedStates[i]; 
    return updatedStates;
  }); 
  setDataUsers((prevDataUsers) => {
    const newDataUsers = [...prevDataUsers];
    newDataUsers[i].admin = itemStates[i] ? '0' : '1' ; 
    return newDataUsers;
  });
  }
const [driverName,setDriverName] = useState()
const handleChecking =() =>{
  const dp = '+963'+ driverPhone.slice(1)
  console.log('dppppppp',dp)
  axios.post(`${process.env.REACT_APP_API_URL}get_driver_phone`, {'phone' : dp} ,{
    headers: {
      Authorization: `Bearer ${mashawiritoken}`,
    },
  }).then(res =>{
    if(res.data.message === 'driver not found'){
      alert(t('driver not exist !'))
    }
    else{
    setDriverName(res.data.data.driver_phone)
    setBtn(false)      
  }
  })
}
  return (
    <>
      <Helmet>
        <title> Dashboard </title>
      </Helmet>
      <Typography sx={{ textAlign: 'center',fontSize:'35px',fontWeight:'bold' }} >
          {t('Create Trip')}
        </Typography>


      
      <Container>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography gutterBottom variant="body1">
              {t('Source')}
            </Typography>
            <TripSource
              setPlace={setCurrent}
              setCity={setCitySrc}
              setSelectedPlace={setSelectedPlaceSrc}
              selectedPlace={selectedPlaceSrc}
              label = {t("From...")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography gutterBottom variant="body1">
              {t('Distination')}
            </Typography>
            <TripSource
              setPlace={setDistination}
              setCity={setCityDis}
              setSelectedPlace={setSelectedPlaceDis}
              selectedPlace={selectedPlaceDis}
              label = {t("To...")}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ marginTop: '8px' }}>
          <Grid xs={12} md={6} item>
            <TextField
              fullWidth
              label={t("Select Car Type")}
              name="state"
              onChange={handleSelecteCar}
              required
              select
              SelectProps={{ native: true }}
              value= {selectedCar}
            >
              {carType.map((car) => (
                <option key={car.id} value={car.id}>
                  {car.name}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid xs={12} md={6} item>
            <TextField
              fullWidth
              label={t("Select Note")}
              name="state"
              onChange={handleSelectNote}
              required
              select
              SelectProps={{ value: selectedNotes, multiple: true }}
              disabled={selectedCar === '' ? true : false}
            >
              {notes.map((note) => (
                <MenuItem key={note.id} value={note.id}>
                  {note.text}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
     
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label={t("Select User")}
              name="state"
              onChange={handleSelectUser}
              required
              select
              SelectProps={{ native: true }}
              // SelectProps={{ value: selecteUser }}
            >
  
              {clients.map((client) => (
                <option key={client.id} id={Admin}
                value={`${client.first_name}-${client.phone}`}>
                  {client.first_name}
                </option>
              ))}

            </TextField>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ marginTop: '20px', alignItems: 'center' }}>
          {dataUsers.map((user, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Typography variant="h6">{selecteUser[index].name}

             <div onClick={() => handleBlackClick(index)}>
              {itemStates[index] ?  
              <StarPurple500SharpIcon 
               sx={{cursor:'pointer',color:'yellow'}} />  :
               <StarOutlineSharpIcon 
               sx={{cursor:'pointer'}} />}
            </div>     
               </Typography>


              <TextField
                label={t("Place")}
                fullWidth
                value={user.region}
                onChange={(e) => handleUserPlaceChange(e, index)}
                sx={{ mb: 3 }}
              >
              </TextField>
            </Grid>
          ))}
        </Grid>


        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
         
            <TextField
              label = {t("Driver Phone Number")}
              fullWidth
              type='number'
              sx={{ mb: 3 }}
              value={driverPhone}
              onChange={(e) => setDriverPhone(e.target.value) }
              >
              </TextField> 
           </Grid>


           <Grid item xs={12} md={6}>
            {btn ?
         <Button sx={{ marginTop:'10px' }}  variant="contained" 
         onClick={handleChecking}>{t('Check if Driver Exist')}</Button>
        : <>
          <Typography>{t('The driver has been selected successfully')} {' '}
            <DoneOutlineIcon sx={{ color:'green' }}/>
          </Typography>
        </>
      }
        </Grid>
      </Grid>

        <Grid xs={12} md={6} item sx={{ marginBottom:'20px' }}>
            <FormControlLabel
              label={t("schedule Trip")}
              control={<Checkbox checked={scheduled} onChange={handleChangeScheduled} />}
            />
            <br/>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker value={selectedDateTime} onChange={handleChangeTime} disablePast disabled={!scheduled} />
            </LocalizationProvider>
          </Grid>
          
        <Button variant="contained" onClick={handleCreateTrip} >
          {loading ? <CircularProgress sx={{ color: '#fff' }} /> : t('Create Trip')}
        </Button>
      </Container>
      {/* <Button onClick={handleLogin}>login socket</Button> */}
    </>
  );
}
